<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onSubmit('SAVE','保存成功')" v-acl="RMC_PROD_PCQTY_SUBMIT" v-if="detailForm.status!=='SUBMITTED'&&ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!==-1&&!isDisabled">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit('SUBMITTED','提交成功')" v-acl="RMC_PROD_PCQTY_SUBMIT" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!==-1&&!isDisabled">提交</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="120px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">基本信息</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="单据号" prop="documentNo">
                  <el-input v-model="detailForm.documentNo" disabled placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="报告期限" prop="month" class="is-required" :rules="rules.month">
                  <el-date-picker v-model="detailForm.month" :disabled="isDisabled" type="month" value-format="yyyy-MM" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Code" class="is-required" :rules="rules.category3Code">
                  <el-select v-model="detailForm.category3Code" disabled style="width:100%">
                    <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商" prop="sponsorName">
                  <el-input v-model="detailForm.sponsorName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="状态" prop="status">
                  <ic-select v-model="detailForm.status" table="TT_RMC_PROTEIN_PURCHASE" field="STATUS" disabled placeholder="请选择" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="ttRmcProducePurchaseId&&detailForm.status!=='DRAFT'">
              <el-col :span="24">
                <el-form-item label="上次修改原因" prop="lastRemarks" class="is-required">
                  <el-input v-model="lastRemarks" disabled type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="修改原因" prop="remarks" :class="ttRmcProducePurchaseId&&detailForm.status!=='DRAFT'?'is-required':''" :rules="rules.remarks">
                  <el-input v-model="detailForm.remarks" :disabled="isDisabled" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">采购量维护</p>
          </div>
          <div class="form_box">
            <el-row style="margin-bottom:5px" type="flex" justify="space-between" align="middle">
              <el-col :span="13">
                <el-button size="small" type="primary" @click="onAddFarm" v-acl="RMC_PROD_PCQTY_ADD_FARM" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!==-1&&!isDisabled">新增Farm</el-button>
                <el-button size="small" type="danger" @click="onDelFarm" v-acl="RMC_PROD_PCQTY_DEL_FARM" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!==-1&&!isDisabled">删除Farm</el-button>
                <el-button size="small" type="primary" @click="onMaintainSupplier" v-acl="RMC_PROD_PCQTY_PICK_SUPP" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!==-1&&!isDisabled">维护供应商</el-button>
                <el-button size="small" type="primary" @click="onExport" v-acl="RMC_PROD_PCQTY_EXPORT" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!==-1&&!isDisabled">导出</el-button>
                <el-button size="small" type="primary" @click="onBatchUpload" v-acl="RMC_PROD_PCQTY_IMPORT" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!==-1&&!isDisabled">导入</el-button>
                <!-- <el-upload ref="upload" :on-error="importDetailError" :on-success="importDetailSuccess" :before-upload="beforeUpload" :action="importDetailUrl" :data="{ttRmcProducePurchaseId: this.ttRmcProducePurchaseId ? this.ttRmcProducePurchaseId : ' ',month: this.detailForm.month ? this.detailForm.month : null}" multiple="false" :headers="headers" :show-file-list="false" name="file" accept=".xls,.xlsx" style="margin-left:10px;display:inline-block">
                  <el-button slot="trigger" size="small" type="primary" v-acl="RMC_PROD_PCQTY_IMPORT" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!==-1&&!isDisabled">导入</el-button>
                </el-upload> -->
              </el-col>
              <el-col :span="11">
                <span>提示:供应商/Facility,如果是供应商选择以后字体默认为蓝色,最多20家供应商伙伴</span>
              </el-col>
            </el-row>
            <el-table ref="plxTable" @selection-change="selectionChange" @row-class-name="rowClassName" :key="Math.random()" :data="tableData" max-height="500" border highlight-current-row>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column type="index" label="序号" width="50">
                <template slot-scope="scope">
                  {{(scope.$index+1)*10}}
                </template>
              </el-table-column>
              <el-table-column label="Farm" prop="farmName" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="作物" prop="crop" align="center" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.crop" :disabled="isDisabled" clearable style="width:100%">
                    <el-option :key="index" v-for="(item,index) in scope.row.cropList" :label="item.name" :value="item.code"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <template v-for="(item,index) in columns">
                <el-table-column :label='item.supplierName' :prop="item.purchaseQuantity" :key="index" min-width="190" show-overflow-tooltip>
                  <template slot="header">
                    <p :class="item.type===2?'blueClass':''">{{item.supplierName}}</p>
                  </template>
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.farmDetail[index].purchaseQuantity" :disabled="isDisabled"></el-input>
                    <!-- <p v-for="(v,i) in scope.row.farmDetail" :key="i">
                    <el-input v-model="v.purchaseQuantity" v-if="v&&item.supplierCode===v.supplierCode"></el-input>
                  </p> -->
                    <!-- <span>{{v&&item.supplierCode===v.supplierCode?v.purchaseQuantity:''}}</span> -->
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="Farm主数据" v-if="dialogFarmVisible" :visible.sync="dialogFarmVisible" :modal-append-to-body="false" width="85%" @close="onCloseFarm">
      <farm-Dialog @onCloseFarm="onCloseFarm" :rmcProduceFarmIdLists="rmcProduceFarmIdLists" @setFarm="setFarm"></farm-Dialog>
    </el-dialog>
    <el-dialog title="供应商主数据" v-if="dialogSupplierVisible" :visible.sync="dialogSupplierVisible" :modal-append-to-body="false" width="85%" @close="onCloseSupplier">
      <supplier-Dialog @onCloseSupplier="onCloseSupplier" :data="labelCloumns" @setSupplier="setSupplier" @setFacility="setFacility"></supplier-Dialog>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="dialogBatchUploadVisible" width="40%" :close-on-click-modal="false" @close="onCloseUpload">
      <el-row style="margin-bottom:10px">
        <el-upload ref="batchUpload" :headers="header" :action="importDetailUrl" :data="{ttRmcProducePurchaseId: this.ttRmcProducePurchaseId ? this.ttRmcProducePurchaseId : ' ',month: this.detailForm.month ? this.detailForm.month : null}" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :on-change="handleChange" :file-list="fileList" :auto-upload="false" :show-file-list="false" style="display:inline-block;margin-right:10px">
          <el-button size="small" type="primary">选取文件</el-button>
        </el-upload>
        <el-link type="button" target="_blank" href="static/template/qspi/Produce采购量维护.xlsx" download="Produce采购量维护.xlsx">
          <el-button class="btn" type="primary" size="small" style="height:100%">导入模板下载</el-button>
        </el-link>
      </el-row>
      <el-form :model="uploadForm" ref="uploadForm">
        <el-form-item>
          <el-input v-model="uploadForm.fileName" readonly></el-input>
        </el-form-item>
      </el-form>
      <el-row>
        <h4>说明:</h4>
        <ul>
          <li>1.请点击模板下载,按照模板填写后再上传</li>
          <li>2.模板中红色字段为必填项,请务必正确填写</li>
          <li>3.仅支持上传Excel格式文件,且大小不能超过20M</li>
          <li>4.为保证上传成功,请勿对模板中的单元格进行修改</li>
          <li>5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
        </ul>
      </el-row>
      <el-row type="flex" justify="center">
        <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onClose1">关闭</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import rmcProdPurchaseApi from "@/api/rmcProduce/purchase";
import commonConstants from "@/constants/commonConstants";
import farmDialog from "./farm.vue"
import supplierDialog from "./supplier.vue"
import { Loading } from "element-ui";
import { Message } from "element-ui";
export default {
  name: "rmcProdPurchaseDetail",
  components: {
    IcSelect,
    farmDialog,
    supplierDialog,
  },
  data() {
    return {
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      ms_roles: null,
      labelCloumns: null,//原始存在的集团和facility数据
      isDisabled: false,
      dialogFarmVisible: false,
      dialogSupplierVisible: false,
      dialogBatchUploadVisible: false,
      rules: {
        month: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择报告期限')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        category3Code: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择Category3')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        // 新建时，不校验必填，审核通过以后再维护时校验必填
        remarks: [
          {
            validator: (rule, value, callback) => {
              if (this.ttRmcProducePurchaseId && this.detailForm.status !== 'DRAFT' && !value) {
                this.$message.error('请输入修改原因')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ],
      },
      uploadForm: {
        fileName: "",
      },
      detailForm: {},
      fileList: [],
      tableData: [],//表格数据
      columns: [],//动态label数组
      category3CodeOptions: [],
      ms_Permission: [],
      original_code: [],
      cropAndFarm: [],
      rmcProduceFarmIdLists: [],
      lastRemarks: "",
      ttRmcProducePurchaseId: "",
    }
  },
  watch: {
  },
  computed: {
    uploadUrl() {
      return commonConstants.fileUploadUrl;
    }
  },
  created() {
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    if (this.$route.query.from === 'edit') {
      this.ttRmcProducePurchaseId = this.$route.query.ttRmcProducePurchaseId
      this.getDetailInfo(this.ttRmcProducePurchaseId)
    } else {
      this.getFarmLists()
    }
  },
  computed: {
    importDetailUrl() {
      return commonConstants.baseUrl + `rmc/produce/purchase/rmcProducePurchaseImportExcel`;
    },
    headers() {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    },
  },
  mounted() {
    this.getSelection();
  },
  methods: {
    onClick(row, col, val) {
      console.log('row', row);
      console.log('col', col);
      console.log('scope.row.farmDetail[index]', val);
    },
    getDetailInfo(ttRmcProducePurchaseId) {
      var ms_userId = JSON.parse(localStorage.getItem('ms_userId'))
      console.log('ms_userId', ms_userId);
      rmcProdPurchaseApi.findListPage({
        ttRmcProducePurchaseId: ttRmcProducePurchaseId
      }).then(res => {
        this.detailForm = res.data.records[0]
        this.lastRemarks = res.data.records[0].remarks
        if (this.ttRmcProducePurchaseId && this.detailForm.status !== 'DRAFT') {
          this.detailForm.remarks = ''
        }
        this.tableData = res.data.records[0].farmProducePurchaseList
        this.tableData.forEach((ele, index) => {
          this.$set(ele, 'row_index', index)
        })
        this.columns = res.data.records[0].colNameList
        // 当前用户是createby时可以编辑，其它情况只能查看
        if (res.data.records[0].createBy !== ms_userId) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      });
    },
    getFarmLists() {
      rmcProdPurchaseApi.getFarm().then(res => {
        console.log('获取farm列表数据', res);
        this.tableData = res.farmProducePurchaseList
        this.detailForm.sponsorName = res.sponsorName
        this.detailForm.sponsorCode = res.sponsorCode
      });
    },
    getSelection() {
      rmcProdPurchaseApi.getSelection(['rmc.RmcCategory3']).then(res => {
        console.log('获取下拉框', res);
        this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
          return v.cascadeKey === 'produce'
        })
        if (this.category3CodeOptions.length === 1) {
          this.$set(this.detailForm, 'category3Code', this.category3CodeOptions[0].key)
        }
      });
    },
    // 导出
    onExport() {
      var obj = {
        month: this.detailForm.month,
        category3Code: this.detailForm.category3Code,
        sponsorCode: this.detailForm.sponsorCode,
        sponsorName: this.detailForm.sponsorName,
        remarks: this.detailForm.remarks,
        farmList: this.tableData
      }
      this.category3CodeOptions.forEach(ele => {
        if (ele.key === this.detailForm.category3Code) {
          this.$set(obj, 'category3Name', ele.object)
        }
      })
      rmcProdPurchaseApi.rmcProducePurchaseExport(obj).then(res => {
        fileService.respToFile(res, 'Produce采购量维护.xlsx');
      })
    },
    onBatchUpload() {
      this.dialogBatchUploadVisible = true
      this.uploadForm.fileName = ''
      this.fileList = []
    },
    beforeUpload(file) {
      console.log('beforeUpload', file);
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isExcel) {
        this.$my_message('请选择Excel文件上传', 'error');
      }
      if (!isLt50M) {
        this.$my_message('附件大小不得超过50M', 'error');
      }
      return isExcel && isLt50M;
    },
    uploadSuccess(resp) {
      console.log('resp', resp);
      if (resp.code == '200') {
        this.$message.success('您已成功导入数据' + resp.data.records[0].farmProducePurchaseList.length + '条');
        this.tableData = resp.data.records[0].farmProducePurchaseList
        this.columns = resp.data.records[0].colNameList
        // this.getDetailInfo(this.ttRmcProducePurchaseId)
      } else {
        this.$message.error(resp.meta.msg)
      }
      this.dialogBatchUploadVisible = false
      this.fileList = []
      this.$set(this.uploadForm, "fileName", '')
      this.$refs.batchUpload.clearFiles();
    },
    handleChange(file, fileList) {
      console.log('file', file);
      console.log('fileList', fileList);
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
      }
      this.uploadForm.fileName = file.name
    },
    onUpload() {
      this.$refs.batchUpload.submit();
    },
    uploadError(error) {
      console.log('error', error);
      let resp = error.toString()//转字符串
      resp = resp.replace('Error:', '')//去掉前面的字符串
      resp = JSON.parse(resp)
      console.log('resp', resp);
      var data = resp.data.split(',')
      console.log('data', data);
      var successNum = Number(data[0].split('{')[1].split(':')[1])
      console.log('successNum', successNum);
      var errorNum = Number(data[1].split('}')[0].split(':')[1])
      console.log('errorNum', errorNum);
      var total = Number(successNum + errorNum)
      if (resp.code == 200) {
        this.$message.success('您已成功导入数据' + successNum + '条');
        this.queryData();
      } else {
        console.log('resp.msg', resp.msg);
        var totalText = '导入文件数据共 ' + total + ' 条'
        var successText = '满足导入条件: ' + successNum + ' 条'
        var errorText = '不满足导入条件: ' + errorNum + ' 条'
        var sumText = '如果存在导入失败的数据,请导出失败原因,修改后再重新上传'
        const wordText = [totalText, successText, errorText, sumText]
        var newArr = []
        const h = this.$createElement;
        for (const i in wordText) {
          newArr.push(h('p', null, wordText[i]))
        }
        this.$confirm('导入结果', {
          title: '导入结果',
          message: h('div', null, newArr),
          showCancelButton: true,
          confirmButtonText: '导出失败原因',
          confirmButtonClass: "confirmButtonClass",
          cancelButtonClass: "cancelButtonClass",
          cancelButtonText: '取消',
          customClass: "uploadBtn",
          type: 'warning'
        }).then(() => {
          let str = new Blob([resp.msg], { type: 'text/plain;charset=utf-8' })
          saveAs(str, '导入失败原因报表.txt')
        }).catch(() => {
          this.$message.info('已取消导出失败原因')
        })
      }
      this.dialogBatchUploadVisible = false
      this.fileList = []
      this.$set(this.uploadForm, "fileName", '')
    },
    onClose1() {
      this.dialogBatchUploadVisible = false
      this.uploadForm.fileName = ''
      this.fileList = []
    },
    selectionChange(val) {
      console.log('val', val);
      this.cropAndFarm = []
      val.forEach((ele) => {
        this.cropAndFarm.push(ele.crop + ele.farmName + ele.row_index)
      })
      console.log('cropAndFarm', this.cropAndFarm);
    },
    onAddFarm() {
      this.dialogFarmVisible = true
      if (this.tableData.length > 0) {
        var rmcProduceFarmIdLists = this.tableData.map(el => {
          return el.farmName
        })
        this.rmcProduceFarmIdLists = rmcProduceFarmIdLists
      }
    },
    // 添加Farm
    setFarm(val) {
      console.log('this.tableData11111111111', this.tableData);
      console.log('this.columns', this.columns);
      console.log('添加Farm', JSON.parse(val));
      var arr = JSON.parse(val)
      // 如果有新增的数据
      if (arr.length > 0) {
        // 如果有表格数据
        if (this.tableData.length > 0) {
          arr.forEach((ele, index) => {
            var item = {
              farmDetail: this.columns,
              farmName: ele.farmName,
              crop: ele.crop.split(',').length > 1 ? '' : ele.crop,
              cropList: ele.cropList,
              rmcProduceFarmId: ele.rmcProduceFarmId,
              // row_index: this.tableData.length
            }
            this.tableData.push(JSON.parse(JSON.stringify(item)))
            // }
          })
        } else {
          arr.forEach((ele, index) => {
            var item = {
              farmDetail: this.columns,
              farmName: ele.farmName,
              crop: ele.crop.split(',').length > 1 ? '' : ele.crop,
              cropList: ele.cropList,
              rmcProduceFarmId: ele.rmcProduceFarmId,
              // row_index: this.tableData.length
            }
            this.tableData.push(JSON.parse(JSON.stringify(item)))
          });
        }
        this.tableData.forEach((ele, idx) => {
          this.$set(ele, 'row_index', idx)
        })
        console.log(' this.tableData', this.tableData);
      }
      this.dialogFarmVisible = false
    },
    onDelFarm() {
      if (this.cropAndFarm.length === 0) {
        this.$message.error('请先选择数据后再操作');
        return false
      }
      console.log('this.cropAndFarm', this.cropAndFarm);
      //您确定要删除所选记录吗？
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        this.tableData = this.tableData.filter((ele, index) => {
          return !this.cropAndFarm.includes(ele.crop + ele.farmName + ele.row_index)
        })
        this.cropAndFarm = []
      }).catch(() => {
        this.$message.info('已取消删除');
      })
    },
    onCloseFarm() {
      this.dialogFarmVisible = false
    },
    onMaintainSupplier() {
      if (this.tableData.length === 0) {
        this.$message.error('请先选择Farm,再进行维护')
        return false
      }
      this.dialogSupplierVisible = true
      this.labelCloumns = JSON.stringify(this.columns)
    },
    // 维护集团
    setSupplier(val) {
      console.log('维护集团', JSON.parse(val));
      console.log('表头label', this.columns);
      console.log('表格数据', this.tableData);
      // 第一步:整理出原始存在的suppliercode
      this.$nextTick(() => {
        var supplier_arr = JSON.parse(val)
        if (supplier_arr.length > 0) {
          // 第二步,将选中的集团整理成固有的格式
          var format_arr = []
          supplier_arr.forEach(ele => {
            format_arr.push({
              crop: "",
              farmName: '',
              purchaseQuantity: '',
              rmcProduceFarmId: '',
              supplierCode: ele.supplierCode,
              supplierName: ele.supplierName,
              type: 2,
            })
          })
          console.log('第一步,将选中的集团整理成固有的格式', format_arr);
          // 如果不存在原始数据,则添加
          if (this.columns.length === 0) {
            this.columns = format_arr
            this.tableData.forEach((ele, index) => {
              ele.farmDetail = JSON.parse(JSON.stringify(ele.farmDetail.concat(JSON.parse(JSON.stringify(format_arr)))))
            })
          }
        } else {
          this.columns = this.columns.filter(ele => {
            return ele.type !== 2
          })
          console.log('this.columns', this.columns);
          this.tableData.forEach(ele => {
            ele.farmDetail = ele.farmDetail.filter(ele => {
              return ele.type !== 2
            })
          })
          console.log('this.tableData', this.tableData);
        }
      })
      this.$forceUpdate()
      this.dialogSupplierVisible = false
    },
    // 维护Facility
    setFacility(val) {
      console.log('选中的facility数据', JSON.parse(val));
      console.log('表头label', this.columns);
      console.log('表格数据', this.tableData);
      this.$nextTick(() => {
        if (this.columns.length > 0) {
          // 第一步,整理出原始存在的facilitycode
          this.original_code = this.columns.filter(ele => {
            return ele.type === 1
          }).map(el => {
            return el.supplierCode
          })
          console.log('第一步,整理出原始存在的facilitycode', this.original_code);
        }
        // 第二步,将选中的facility整理成固有的格式
        var ficility_arr = JSON.parse(val)
        if (ficility_arr.length > 0) {
          var format_arr = []
          ficility_arr.forEach(ele => {
            format_arr.push({
              crop: "",
              farmName: null,
              purchaseQuantity: null,
              rmcProduceFarmId: '',
              supplierCode: ele.supplierCode,
              supplierName: ele.supplierName,
              type: 1,
            })
          })
          console.log('第二步,将选中的facility整理成固有的格式', format_arr);
          // 第三步,筛选出新增加的facility
          var add_facility = format_arr.filter(ele => {
            return !this.original_code.includes(ele.supplierCode)
          })
          console.log('第三步,筛选出新增加的facility', add_facility);
          // 第四步,将整理好的选中的数据push到原始的label数组中,切记必须是push到最后面
          var temp_arr = [...this.columns]
          format_arr.forEach(ele => {
            temp_arr.push(ele)
          })
          console.log('第四步,将整理好的选中的数据push到原始的label数组中', temp_arr);
          if (this.columns.length > 0) {
            // 第五步,去重
            var hash = {}
            temp_arr = temp_arr.reduce(function (item, next) {
              hash[next.supplierCode] ? '' : hash[next.supplierCode] = true && item.push(next)
              return item
            }, [])
            console.log('第五步,去重', temp_arr);
          }
          // 第六步,整理出选中的facility label的code
          var facility_code = []
          facility_code = format_arr.map(ele => {
            return ele.supplierCode
          })
          console.log('第六步,整理出选中的facility label的code', facility_code);
          // 第七步,从去重后的label中找到已被删除的facility的index
          var facility_index = temp_arr.filter(ele => {
            return ele.type === 1 && !facility_code.includes(ele.supplierCode)
          }).map(el => {
            return el.supplierCode
          })
          console.log('第七步,从去重后的label中找到已被删除的facility的index', facility_index);
          // 第八步,从去重后label中去除已经删除的label
          if (facility_index.length > 0) {
            // temp_arr.splice(facility_index, 1)
            temp_arr = temp_arr.filter(ele => {
              return !facility_index.includes(ele.supplierCode)
            })
            console.log('第八步,从去重后label中去除已经删除的label', this.columns);
          }
          this.columns = [...temp_arr]
          if (this.tableData.length > 0) {
            // 第九步,从原始tableData中添加选中的列
            this.tableData.forEach((ele, index) => {
              ele.farmDetail = JSON.parse(JSON.stringify(ele.farmDetail.concat(JSON.parse(JSON.stringify(add_facility)))))
            })
            console.log('第九步,从原始tableData中添加选中的列', this.tableData);
            // 第十步,从原始tableData中删除已被删除的列
            if (facility_index.length > 0) {
              this.tableData.forEach(ele => {
                // ele['farmDetail'].splice(facility_index, 1)
                ele.farmDetail = ele.farmDetail.filter(el => {
                  return !facility_index.includes(el.supplierCode)
                })
              })
              console.log('第十步,从原始tableData中删除已被删除的列', this.tableData);
            }
          }
        } else {
          console.log('312');
          this.columns = this.columns.filter(ele => {
            return ele.type !== 1
          })
          this.tableData.forEach(ele => {
            ele.farmDetail = ele.farmDetail.filter(ele => {
              return ele.type !== 1
            })
          })
          console.log('this.columns', this.columns);
          console.log('this.tableData', this.tableData);
        }
      })
      this.$forceUpdate()
      this.dialogSupplierVisible = false
    },
    onSubmit(type, msg) {
      console.log('this.tableData', this.tableData);
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var flag1 = false
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].farmDetail.length === 0) {
              this.$message.error('请维护供应商')
              flag1 = true
            }
            if (this.tableData[i].farmDetail.length > 20) {
              this.$message.error('最多20家供应商伙伴')
              flag1 = true
            }
          }
          if (flag1) {
            return false
          }
          var flag2 = false
          for (let i = 0; i < this.tableData.length; i++) {
            if (!this.tableData[i].crop) {
              this.$message.error('第' + (i + 1) + '行,作物为空')
              flag2 = true
            }
          }
          if (flag2) {
            return false
          }
          var flag3 = false
          var arry = []
          for (let i = 0; i < this.tableData.length; i++) {
            arry.push({
              group: this.tableData[i].farmName + this.tableData[i].crop,
              farmName: this.tableData[i].farmName,
              crop: this.tableData[i].crop,
            })
            let res = this.isRepeat(arry, 'group', true)
            if (res) {
              this.$message.error(res)
              flag3 = true
            }
          }
          console.log('arry', arry);
          if (flag3) {
            return false
          }
          var flag4 = false
          for (let i = 0; i < this.tableData.length; i++) {
            const item = this.tableData[i];
            var valid = item.farmDetail.every(ele => {
              return !ele.purchaseQuantity
            })
            console.log('valid', valid);
            if (valid) {
              this.$message.error(item.farmName + 'Farm+' + item.crop + '作物行项目需维护至少一个采购量数据.')
              flag4 = true
            }
            if (flag4) {
              return false
            }
          }
          var flag5 = false
          for (let i = 0; i < this.tableData.length; i++) {
            const item = this.tableData[i];
            for (let j = 0; j < item.farmDetail.length; j++) {
              const ele = item.farmDetail[j];
              var reg = /^-?\d+(\.\d{0,2})?$/
              if (ele.purchaseQuantity && !reg.test(ele.purchaseQuantity)) {
                this.$message.error('第' + (i + 1) + '行,字段"' + ele.supplierName + '"输入格式不满足要求（格式：数字,最多两位小数），请检查.')
                flag5 = true
              }
            }
          }
          if (flag5) {
            return false
          }
          console.log('tableData', this.tableData);
          console.log('columns', this.columns);
          var obj = {
            month: this.detailForm.month,
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            sponsorName: this.detailForm.sponsorName,
            remarks: this.detailForm.remarks,
            type: type,
            farmList: this.tableData
          }
          this.category3CodeOptions.forEach(ele => {
            if (ele.key === this.detailForm.category3Code) {
              this.$set(obj, 'category3Name', ele.object)
            }
          })
          // if (this.$route.query.from === 'edit') {
          this.$set(obj, 'ttRmcProducePurchaseId', this.ttRmcProducePurchaseId)
          // }
          rmcProdPurchaseApi.updateProteinPurchase(obj).then(res => {
            console.log('保存', res);
            if (res.meta.code === 200) {
              this.ttRmcProducePurchaseId = res.data
              this.$message.success(msg)
              if (type === 'SUBMITTED') {
                this.$router.go(-1)
              } else {
                this.getDetailInfo(res.data)
              }
            } else {
              this.$message.error(res.meta.msg)
              if (this.$route.query.from === 'edit') {
                this.ttRmcProducePurchaseId = this.$route.query.ttRmcProducePurchaseId
              }
            }
          });
        }
      })
    },
    isRepeat(arry, key, checkVoid = false) {
      let arr = []
      let check = ''
      arry.some((item) => {
        if (arr.includes(item[key])) {
          return check = `${item.farmName}Farm+${item.crop}作物有重复`
        }
        arr.push(item[key])
        return false
      })
      return check
    },
    onCloseSupplier() {
      this.dialogSupplierVisible = false
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style>
</style>